/** Évolution par rapport à la période d'avant (« +12 % », « nouveau », « = »). */
import { ArrowDownRight, ArrowUpRight, Minus } from 'lucide-react';
import { cn } from '@jeraisonne/ui';
import { trend } from '@/lib/admin/live-stats';

export function TrendBadge({ cur, prev }: { cur: number; prev: number }) {
  const t = trend(cur, prev);
  const Icon = t.dir === 'up' ? ArrowUpRight : t.dir === 'down' ? ArrowDownRight : Minus;
  return (
    <span
      className={cn(
        'inline-flex items-center gap-0.5 rounded-full px-1.5 py-0.5 text-xs font-semibold tabular-nums',
        t.dir === 'up' && 'bg-emerald-50 text-emerald-700',
        t.dir === 'down' && 'bg-red-50 text-red-700',
        t.dir === 'flat' && 'bg-ink-50 text-ink-500',
      )}
    >
      <Icon className="h-3 w-3" aria-hidden />
      {t.label}
    </span>
  );
}
